import "./BBS.css";

import {getRootUrl} from '../consts.js'

import {useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";

const rootUrl = getRootUrl();

export default function BBS({Header}){
    const navigate = useNavigate();

    useEffect(()=>{
        // const chkUser = ()=>{
        //     if(!localStorage.getItem("_id")){
        //         navigate(rootUrl+"/login");
        //     }else{
        //         console.log("authorized.");
        //     }
        // };

        // chkUser();
    })

    return <>
        <h1>BBS BBS</h1>
        <div className="container">
            <div className="row">
                <div className="col-md-8 offset-md-2">
                    <span>modal dialog</span>

                </div>
            </div>
            <div className="row">
                <div className="col-md-8 offset-md-2">

                    {/* <!-- Button trigger modal --> */}
                    <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
                    Launch demo modal
                    </button>

                    <div className="modal" id="exampleModal"  tabIndex="-1">
                        <div className="modal-dialog">
                            <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Modal title</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <p>Modal body text goes here.</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="button" className="btn btn-primary">Save changes</button>
                            </div>
                            </div>
                        </div>
                    </div>

                    
                </div>
            </div>
        </div>

    </>;
}